module.exports = __webpack_public_path__ + "img/ico8.bc92deae.svg";